define([
    "dojo/_base/declare",
    "csi/form/Widget"
], function(declare,Widget) {

    return declare(Widget, {

        _updateFieldVisibility: function(/*Field?*/field) {
            // summary: set visibility of fields
            this.inherited(arguments);
            this.setFieldHidden("EnableBreadcrumbSearch", !this.defView.getFieldValue("ManagePreferences"));
        }
    });
});